<div class="wetter_content_container">

  <div class="left">
    <h3>{{getBundesLaenderNamenHeader()}}</h3>
    <span class="station_count_label">Anzahl Stationen: <span
      style="color: #2196f3">{{datastoreService?.vorhersagen24hHeute?.length}}</span>
  </span>



    <mat-chip-list label="Weitere Spalten:" [multiple]="true" class="optional_col_chip_list"
                   aria-label="Weitere Spalten">
      <mat-chip class="mat_chip_optional_column" [selectable]="true" (click)="addColumn(col)" [selected]="col.selected"
                *ngFor="let col of additionalColumns">{{col.displayName}}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="right">
    <app-searchbar></app-searchbar>
  </div>
  <table #table mat-table [dataSource]="dataSource" class="mat-elevation-z4" matSort matSortActive="ort"
         matSortDirection="asc">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
      <td mat-cell *matCellDef="let element">{{element?.ort?.id}}</td>
      <td mat-footer-cell class="mat_footer" *matFooterCellDef>
      </td>
    </ng-container>

    <ng-container matColumnDef="typ">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Typ</th>
      <td mat-cell *matCellDef="let element">{{element?.ort?.typ}}</td>
      <td mat-footer-cell *matFooterCellDef></td>

    </ng-container>

    <ng-container matColumnDef="ort">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ort</th>
      <td mat-cell *matCellDef="let element">{{element?.ort?.name}}</td>
      <td mat-footer-cell *matFooterCellDef>{{date | date: 'EE HH:mm yy'}}
        <button mat-button (click)="refreshData();">
          <mat-icon class="boxed_icon">refresh</mat-icon>
        </button>
      </td>

    </ng-container>

    <ng-container matColumnDef="wettersymbol">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <mat-icon>cloud_queue</mat-icon>
      </th>
      <td mat-cell *matCellDef="let element"><img width="58px" style="margin-left: -20px"
                                                  src="{{datastoreService.getWetterSymbolUrl(element?.tag00?.werteGanzerTag?.wettersymbol?.wert)}}">
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="temperaturMin">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <mat-icon svgIcon="thermometer_min"></mat-icon>
      </th>
      <td mat-cell
          *matCellDef="let element">{{werteConverter.convertDecimalWithComma(element?.tag00?.werteGanzerTag?.luftTemperaturMinimum.wert)}} {{element?.tag00?.werteGanzerTag?.luftTemperaturMinimum.einheit}}</td>
      <td mat-footer-cell *matFooterCellDef></td>

    </ng-container>

    <ng-container matColumnDef="temperaturMax">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <mat-icon svgIcon="thermometer_max" style="color: #ffa500"></mat-icon>
      </th>
      <td mat-cell
          *matCellDef="let element">{{werteConverter.convertDecimalWithComma(element?.tag00?.werteGanzerTag?.luftTemperaturMaximum.wert)}} {{element?.tag00?.werteGanzerTag?.luftTemperaturMaximum.einheit}}</td>
      <td mat-footer-cell *matFooterCellDef></td>

    </ng-container>


    <ng-container matColumnDef="niederschlag">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <mat-icon>umbrella</mat-icon>
      </th>
      <td mat-cell
          *matCellDef="let element">{{element?.tag00?.werteGanzerTag?.niederschlagsWahrscheinlichkeit.wert }} {{element?.tag00?.werteGanzerTag?.niederschlagsWahrscheinlichkeit.einheit}}</td>
      <td mat-footer-cell *matFooterCellDef></td>

    </ng-container>

    <ng-container matColumnDef="24hLink">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>10Tage/24h</th>
      <td mat-cell *matCellDef="let element">
        <button mat-button [routerLink]="['24-stunden']" [queryParams]="{id: element?.ort?.id}"
                (click)="showDetails = true">
          <span class="detail_link"><mat-icon class="boxed_icon">show_chart</mat-icon></span>
        </button>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>

    </ng-container>

    <ng-container matColumnDef="3hLink">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>10Tage/3h</th>
      <td mat-cell *matCellDef="let element">
        <button mat-button [routerLink]="['3-stunden']" [queryParams]="{id: element?.ort?.id}"
                (click)="showDetails = true">
          <span class="detail_link"><mat-icon class="boxed_icon">show_chart</mat-icon></span>
        </button>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>

    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

    <!-- Row shown when there is no matching data. -->
    <!--    <tr class="mat-row" *matNoDataRow>-->
    <!--      <td class="mat-cell" colspan="4">Finde keine passenden Daten zur Suche: "{{dataSource.filter}}"</td>-->
    <!--    </tr>-->
  </table>
  <mat-paginator (page)="scrollUp()" [pageSizeOptions]="[100,200,500,dataSource?.data?.length]"
                 showFirstLastButtons></mat-paginator>
</div>




